export default {"src":"/_next/static/media/rating-improvement.682b6220.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};